import type { UploadTask } from '@freelancer/file-storage';

/**
 * Contains the data of either an uploaded file or a file that is being uploaded
 */
export type FileData<T> = BaseFileData & (UploadedFile<T> | TemporaryFile);

interface BaseFileData {
  name: string;
  // eg. contest id
  sourceId: number;
}

interface UploadedFile<T> {
  id: number;
  url: string;
  // Type is the type of the files collection used
  type: T;
}

interface TemporaryFile {
  id?: undefined;
  url?: undefined;
  // Type is the MIME file type
  type: string;
}

/**
 * Contains the data used to list the files in the table.
 */
export type FilesBodyData<T> = UploadedFilesData<T> | UploadingFilesData;

export interface UploadedFilesData<T> {
  file: BaseFileData & UploadedFile<T>;
  // Used for the file preview modal
  // Indexes are assigned to each file in `files-table.component`
  index?: number;
  uploadDone: true;
}

export interface UploadingFilesData {
  file: BaseFileData & TemporaryFile;
  uploadTask: UploadTask;
  // Used for reuploads
  uploadingFile: File;
  uploadDone: false;
}

/** Values are used as the display text for the filters */
export enum FileFilter {
  ALL_FILES = 'all files',
  DOCUMENTS = 'documents',
  IMAGES = 'images',
  VIDEOS = 'videos',
  OTHER = 'others',
}
